import $ from 'jquery'

const enable = () => {
  $('.c-share__btn').on('click', (e) => {
    e.preventDefault()
    $('.c-share__content').addClass('is-open')
  })

  $('.c-share__close').on('click', (e) => {
    e.preventDefault()
    $('.c-share__content').removeClass('is-open')
  })
}

export default { enable }
